module.exports = __webpack_public_path__ + "img/netavg2.a3fdc53d.jpg";